import { useState } from 'react'
import { Form } from 'antd'

const useModalState = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [showDetailsFor, setShowDetailsFor] = useState(null)
  const [form] = Form.useForm()

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
    form.resetFields()
  }

  const handleAdd = () => {
    form
      .validateFields()
      .then((values) => {
        // In a real application, this would add the new surgery to the database
        setIsModalVisible(false)
        form.resetFields()
      })
      .catch((info) => {})
  }

  const handleShowDetails = (surgery) => {
    setShowDetailsFor(surgery)
  }

  const handleCloseDetails = () => {
    setShowDetailsFor(null)
  }

  return {
    isModalVisible,
    showDetailsFor,
    form,
    showModal,
    handleCancel,
    handleAdd,
    handleShowDetails,
    handleCloseDetails
  }
}

export default useModalState
